/**
 * DeleteTemplateDialog — AlertDialog confirmation for template deletion.
 *
 * Extracted as-is from BlogTemplatesPage (Phase 1 decomposition).
 */

import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { BlogTemplateSummary } from '@/services/blogTemplatesService';

export interface DeleteTemplateDialogProps {
  /** The template pending deletion; null closes the dialog. */
  template: BlogTemplateSummary | null;
  isDeleting: boolean;
  onConfirm: (template: BlogTemplateSummary) => void;
  onOpenChange: (open: boolean) => void;
}

export const DeleteTemplateDialog: React.FC<DeleteTemplateDialogProps> = ({
  template,
  isDeleting,
  onConfirm,
  onOpenChange,
}) => {
  return (
    <AlertDialog open={!!template} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Template</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete "{template?.name}"?
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={isDeleting}
            onClick={() => template && onConfirm(template)}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
